module.exports = __webpack_public_path__ + "img/gastroscopija-400x200.39ac70de.jpg";